<template>
    <q-button class="upLoad-button">
        <input
                type="file"
                class="file"
                @change="onFileChange"
        >
        <span class="fake">{{ this.$qt('el.upload.buttonTitle') }}</span>
    </q-button>
</template>

<script>


  export default {
    name: "QUpload",

    props: {
      value: {
        default: undefined
      },
      type: {
        required: true,
        type: String,
        default: 'text'
      }
    },

    data() {
      return {
        file: '',
        result: undefined,

        image: undefined,
        text: undefined,
        json: undefined
      };
    },
    watch: {
      result() {
        if (this.type === 'image') {
          this.result = this.image
        } else if (this.type === 'json') {
          this.result = this.json;
        } else {
          this.result = this.text;
        }
        this.$emit('input', this.result);
      },
      value() {
        this.result = this.value;
      }
    },
    created() {
      this.result = this.value;
    },

    methods: {
      onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
          return;
        if (this.type === 'image') {
          this.createImage(files[0]);
        } else if (this.type === 'json') {
          this.createJson(files[0])
        } else {
          this.createText(files[0]);
        }
      },

      createText(file) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.text = e.target.result;
          this.result = this.text;
          this.$emit('input', this.result);
        };
        reader.readAsText(file);
      },
      createJson(file) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.json = JSON.parse(e.target.result);
          this.result = this.json;
          this.$emit('input', this.result);
        };
        reader.readAsText(file);
      },
      createImage(file) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.image = e.target.result;
          this.result = this.image;
          this.$emit('input', this.result);
        };
        reader.readAsDataURL(file);
      },
    }

  }
</script>

<style scoped>
    .upLoad-button {
        position: relative;
        padding: 5px;
    }

    .fake {
        position: absolute;
        top: 0;
        width: 100%;
        left: 0;
        height: 100%;
        text-align: center;
        vertical-align: middle;
        padding-top: 7px;
        z-index: 1;
    }

    .file {
        position: relative;
        /*text-align: right;*/
        -moz-opacity: 0;
        filter: alpha(opacity:0);
        opacity: 0;
        z-index: 2;
    }
</style>